import script from "./RecepieDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RecepieDetails.vue?vue&type=script&setup=true&lang=js"

import "./RecepieDetails.vue?vue&type=style&index=0&id=5599cfee&lang=css"

const __exports__ = script;

export default __exports__